import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useSlug } from '@/composables/useSlug';
import type { MenuItem } from '@/interfaces/components/menu/itemsMenu.interface';
import type { Pipeline } from '@/interfaces/pipeline/pipeline.interface';

export const usePipelineStore = defineStore(
  'AtenaPipelineStore',
  () => {
    const pipelines = ref<Pipeline[] | null>(null);
    const urls = ref<Record<string, string>>({});
    const currentPipelineId = ref<string | null>(null);

    const clearPipelines = () => {
      pipelines.value = null;
    };

    const setPipelines = async (payload: Pipeline[]) => {
      pipelines.value = payload;
    };

    const pipelineMenuOptions = (): Array<MenuItem> => {
      if (!pipelines.value) return [];
      return pipelines.value.map((pipeline) => {
        urls.value[useSlug(pipeline.name)] = pipeline.id;
        return {
          name: pipeline.name,
          icon: 'fa-solid fa-grip',
          isDefaultIcon: true,
          route: `/meus-negocios/${useSlug(pipeline.name)}`,
          subItems: [],
          isVisible: true,
        };
      });
    };

    const setCurrentPipelineId = (name: string) => {
      currentPipelineId.value = urls.value[useSlug(name)] ?? null;
    };

    return {
      urls,
      pipelines,
      setPipelines,
      setCurrentPipelineId,
      currentPipelineId,
      clearPipelines,
      pipelineMenuOptions,
    };
  },
  {
    persist: true,
  },
);
